import ThemeSelector from "components/ui/ThemeSelector";

/** Theme control on the signed-out screens: Kuest's ThemeSelector (light / system / dark). */
export default function FixedPlugin(props) {
  const { ...rest } = props;
  return (
    <div
      className="fixed right-4 top-4 !z-[99] flex items-center gap-2 rounded-md border border-border bg-background p-1 pl-2.5 text-sm font-semibold text-foreground shadow-card"
      {...rest}
    >
      <span className="hidden sm:inline">Dark Mode</span>
      <ThemeSelector />
    </div>
  );
}
